module.exports = __webpack_public_path__ + "static/media/53_client_expectations_shortcut.4bd16d15.png";